export default __webpack_public_path__ + "static/media/main4.da957ea6.jpg";